import React, { useState, useEffect } from "react";
import { Modal, Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import { createVendorApi, updateVendorApi } from "../../services/VendorService";
const AddVendorModal = ({ visible, onClose, onAfterSubmit, data = null }) => {
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    name: "",
    email: "",
    mobile_number: "",
    contact_person_name: "",
    address: "",
  });
  const [error, setError] = useState({});

  useEffect(() => {
    if (visible) handleReset();
  }, [visible]);

  const handleReset = () => {
    if (data) {
      setForm({
        name: data?.name || "",
        email: data?.email || "",
        mobile_number: data?.mobile_number || "",
        contact_person_name: data?.contact_person_name || "",
        address: data?.address || "",
      });
    } else {
      setForm({
        name: "",
        email: "",
        mobile_number: "",
        contact_person_name: "",
        address: "",
      });
    }

    setError({});
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "mobile_number") {
      const numericValue = value.replace(/[^0-9]/g, "");
      setForm((prev) => ({ ...prev, [name]: numericValue }));

      if (numericValue.length === 10) {
        if (error?.mobile_number) {
          setError((prev) => ({ ...prev, mobile_number: "" }));
        }
      } else {
        setError((prev) => ({ ...prev, mobile_number: "Must be 10 digits" }));
      }
    } else if (name === "email") {
      const emailValue = value;
      const emailRegex = /^\S+@\S+\.\S+$/;
      setForm((prev) => ({ ...prev, [name]: emailValue }));
      if (emailRegex.test(emailValue)) {
        if (error?.email) {
          setError((prev) => ({ ...prev, email: "" }));
        }
      } else {
        setError((prev) => ({
          ...prev,
          email: "Invalid email format",
        }));
      }
    } else {
      setForm((prev) => ({ ...prev, [name]: value }));
      if (value && error?.[name]) {
        setError((prev) => ({ ...prev, [name]: "" }));
      }
    }
  };

  const handleSubmit = () => {
    let error = {};

    if (!form.name?.trim()) {
      error.name = "Name is required";
    }
    if (!form.mobile_number?.trim()) {
      error.mobile_number = "Mobile number is required";
    } else if (!/^[6-9]\d{9}$/.test(form.mobile_number)) {
      error.mobile_number = "Enter a valid 10-digit mobile number";
    }

    if (!form.email?.trim()) {
      error.email = "Email is required";
    } else if (
      !/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(form.email)
    ) {
      error.email = "Enter a valid email address";
    }

    if (!form.contact_person_name?.trim()) {
      error.contact_person_name = "Contact person name is required";
    }
    if (!form.address?.trim()) {
      error.address = "Address is required";
    }

    setError(error);

    if (Object.keys(error).length === 0) {
      if (data) {
        updateVendor();
      } else {
        addVendor();
      }
    }
  };

  const addVendor = () => {
    setLoading(true);
    createVendorApi(form)
      .then(() => {
        toast.success("Vendor Added successfully");
        onAfterSubmit();
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => setLoading(false));
  };
  const updateVendor = () => {
    setLoading(true);
    updateVendorApi(data?.id || "", form)
      .then(() => {
        toast.success("Vendor update successfully");
        onAfterSubmit();
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => setLoading(false));
  };
  return (
    <Modal show={visible} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>{data ? "Update Vendor" : "Add Vendor"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="p-2">
          <div className="row g-2">
            <div className="col-md-6">
              <label className="form-label text-dark">Name</label>
              <input
                type="text"
                name="name"
                className={`form-control ${error?.name ? "is-invalid" : ""}`}
                value={form.name}
                placeholder="Info pvt ltd"
                onChange={handleInputChange}
              />
              {error?.name && (
                <small className="text-danger">{error.name}</small>
              )}
            </div>
            <div className="col-md-6">
              <label className="form-label text-dark">Email</label>
              <input
                type="text"
                name="email"
                className={`form-control ${error?.email ? "is-invalid" : ""}`}
                value={form.email}
                placeholder="john@gmail.com"
                onChange={handleInputChange}
              />
              {error?.email && (
                <small className="text-danger">{error.email}</small>
              )}
            </div>
            <div className="col-md-6">
              <label className="form-label text-dark">Contact Person</label>
              <input
                type="text"
                name="contact_person_name"
                className={`form-control ${
                  error?.contact_person_name ? "is-invalid" : ""
                }`}
                value={form.contact_person_name}
                placeholder="John deo"
                onChange={handleInputChange}
              />
              {error?.contact_person_name && (
                <small className="text-danger">
                  {error.contact_person_name}
                </small>
              )}
            </div>
            <div className="col-md-6">
              <label className="form-label text-dark">Mobile Number</label>
              <input
                type="text"
                name="mobile_number"
                className={`form-control ${
                  error?.mobile_number ? "is-invalid" : ""
                }`}
                value={form.mobile_number}
                placeholder="9777303064"
                onChange={handleInputChange}
              />
              {error?.mobile_number && (
                <small className="text-danger">{error.mobile_number}</small>
              )}
            </div>
            <div className="col-12">
              <label className="form-label text-dark">Address</label>
              <textarea
                name="address"
                className={`form-control ${error?.address ? "is-invalid" : ""}`}
                value={form.address}
                onChange={handleInputChange}
                rows={2}
                placeholder="Main Road, JP Nagar, Bengaluru, Karnataka – 560078"
              />
              {error?.address && (
                <small className="text-danger">{error.address}</small>
              )}
            </div>
          </div>

          <code className="text-light">
            <strong>Note:</strong> All fields are required.
          </code>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="d-flex justify-content-end gap-2 w-100">
          <button
            className="btn btn-outline-dark"
            disabled={loading}
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className="btn btn-primary"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading && <Spinner animation="border" size="sm" />} Submit
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default AddVendorModal;
